import script from "./PatientRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./PatientRow.vue?vue&type=script&lang=ts&setup=true"

import "./PatientRow.vue?vue&type=style&index=0&id=95a39cd0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95a39cd0"]])

export default __exports__